import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";

interface Tags {
  appTagId: number,
   appTagName: string
}
interface ListTagProps {
  tagsList: Tags[];
}

const ListTags: React.FC<ListTagProps> = ({ tagsList }) => {
  return (
    <>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>App Tags</th>
          </tr>
        </thead>
        <tbody>
          {tagsList.map((tag: Tags, index: number) => (
            <tr key={tag.appTagId}>
              <td>
                <Link to={`${tag.appTagId}`}>{tag.appTagId}</Link>
              </td>
              <td>
                <Link to={`${tag.appTagId}`}>{tag.appTagName}</Link>
              </td>           
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default ListTags;
